import time_limit from "./time-limit.png";
import whatsapp from "./whatsapp.png";

export const images = {
   time_limit,
   whatsapp
  };